// UI micro-strings for KYT — Turkish (tr) and English (en).
// Content blocks (vision, mission, services, certificates...) live in
// src/data/site.js (tr) and src/data/site_en.js (en).

export const ui = {
  tr: {
    "nav.home": "Anasayfa",
    "nav.about": "Kurumsal",
    "nav.services": "Hizmetler",
    "nav.projects": "Projeler",
    "nav.contact": "İletişim",

    "common.catalogOnline": "Online Katalog",
    "common.catalogDownload": "Katalog İndir",
    "common.contactCta": "İletişime Geç",
    "common.emailSend": "E-posta Gönder",
    "common.exploreProjects": "Projelerimizi İncele",
    "common.allProjects": "Tüm Projeler",
    "common.allServices": "Tüm hizmetler",
    "common.viewProject": "Projeyi Gör",
    "common.getQuote": "Ücretsiz Teklif Al",

    "footer.desc":
      "1993'ten bu yana elektrik taahhüt ve mühendislik alanında; hastane, stadyum, AVM, endüstriyel tesis ve konut projelerine güç veriyoruz.",
    "footer.menu": "Menü",
    "footer.projectCategories": "Proje Kategorileri",
    "footer.contact": "İletişim",
    "footer.rights": "Tüm hakları saklıdır.",
    "footer.quickQuote": "Hızlı teklif için yazın",
    "footer.kvkk": "KVKK Aydınlatma Metni",
    "footer.cookies": "Çerez Politikası",
    "footer.legalCol": "Yasal",

    "cookie.text": "Sitemiz yalnızca çalışması için gerekli olan zorunlu yerel kayıtları kullanır; analitik veya reklam çerezi kullanmaz.",
    "cookie.accept": "Tamam",
    "cookie.policy": "Çerez Politikası",

    "home.heroEyebrow": "Elektrik & Mühendislik",
    "home.heroLines": ["Geleceğin", "yapılarına güç", "veriyoruz."],
    "home.heroHighlight": "güç",
    "home.heroPara":
      "{since}'ten bu yana hastane, stadyum, AVM ve endüstriyel tesislerde elektrik taahhüt ve mühendislik çözümleri sunan, güvenilir çözüm ortağınız.",
    "home.scroll": "Kaydır",
    "home.trustedBy": "Güvenilen markaların çözüm ortağı",
    "home.sec01Eyebrow": "Kurumsal",
    "home.sec01Title": "Para değil; müşteri ve dost kazanmak en önemli felsefemizdir.",
    "home.sec01Bullets": [
      "Standartlardan taviz vermeyen, uzman teknik kadro",
      "Zamanında, hatta zamanından önce teslim",
      "Yıllarca kullanılabilen enerji dağıtım sistemleri",
    ],
    "home.aboutMore": "Hakkımızda daha fazlası",
    "home.sec02Eyebrow": "Hizmetlerimiz",
    "home.sec03Eyebrow": "Yakın Zamanda Biten İşler",
    "home.sec03Title": "Öne Çıkan Projeler",
    "home.sec03Desc": "Son dönemde tamamladığımız büyük ölçekli elektrik ve mühendislik projeleri.",
    "home.sec04Eyebrow": "Referanslarımız",
    "home.sec04Title": "Projelerimizden Bir Seçki",
    "home.sec04Desc": "Sağlık, spor, sanayi, AVM ve kamu yapılarında 42'den fazla tamamlanmış proje.",
    "home.certEyebrow": "Kalite Belgelerimiz",
    "home.certTitle": "Uluslararası Standartlarda Hizmet",
    "home.certDesc": "İş süreçlerimizi kalite, çevre ve iş güvenliği standartlarıyla yönetiyoruz.",
    "home.ctaEyebrow": "İletişim",
    "home.ctaTitle": "Projeniz için elektrik ve mühendislik çözümü mü arıyorsunuz?",
    "home.serviceHighlights": [
      { title: "Elektrik Taahhüt", desc: "AG-OG enerji nakil hatları, trafo postaları ve dağıtım panoları." },
      { title: "Otomasyon Sistemleri", desc: "Bina, CCTV ve çevre güvenlik otomasyon çözümleri." },
      { title: "Aydınlatma & Kompanzasyon", desc: "Verimli aydınlatma ve reaktif güç kompanzasyon sistemleri." },
      { title: "Güvenlik & Yangın", desc: "Geçiş kontrol, yangın ihbar ve güvenlik sistemleri." },
    ],

    "about.headerTitle": "Kurumsal",
    "about.headerSubtitle":
      "{legal} — {since}'ten bu yana elektrik ve mühendislik alanında güvenilir çözüm ortağınız.",
    "about.introEyebrow": "Hakkımızda",
    "about.introTitle": "Elektrik enerjisini verimli ve güvenli kılan mühendislik.",
    "about.introDesc":
      "Türkiye ve dünya elektrik sektöründe mühendislik, müşavirlik, taahhüt ve satış konularında faaliyet gösteren firmamız; konusunda uzman teknik kadrosu ve bilinçli sorumluluk anlayışıyla hizmet vermektedir.",
    "about.actEyebrow": "Faaliyet Alanlarımız",
    "about.certEyebrow": "Kalite Belgelerimiz",
    "about.certTitle": "Belgelerimiz & Standartlarımız",
    "about.reachUs": "Bize Ulaşın",

    "services.headerTitle": "Hizmetlerimiz",
    "services.headerSubtitleSuffix":
      " — danışmanlıktan devreye almaya, uçtan uca elektrik ve mühendislik çözümleri.",
    "services.eyebrow": "Elektrik & Mühendislik",
    "services.whyEyebrow": "Neden KYT?",
    "services.whyTitle": "Tasarımdan devreye almaya tek elden çözüm.",
    "services.ctaTitle": "İhtiyacınıza özel çözüm üretelim.",
    "services.steps": [
      { t: "Tasarım & Mühendislik", d: "Projelendirme, hesaplama ve uygulama projeleri." },
      { t: "Tedarik & Montaj", d: "Pano üretimi, kablolama, sonlandırma ve saha montajı." },
      { t: "Test & Devreye Alma", d: "Testler, otomasyon ve sorunsuz devreye alma." },
    ],

    "projects.headerTitle": "Projelerimiz",
    "projects.headerSubtitle":
      "1993'ten bu yana tamamladığımız sağlık, spor, sanayi, AVM, eğitim, sosyal tesis ve konut projeleri.",
    "projects.countSuffix": "proje",
    "projects.refEyebrow": "Diğer Referanslarımız",
    "projects.refTitle": "Birlikte Çalıştığımız Kurumlar",
    "projects.refDesc":
      "Proje galerilerine ek olarak, yıllar içinde elektrik ve mühendislik hizmeti verdiğimiz seçili referanslarımız.",

    "detail.crumb": "Proje Detayı",
    "detail.notFound": "Proje bulunamadı",
    "detail.backAll": "Tüm projelere dön",
    "detail.specsTitle": "Proje Künyesi",
    "detail.specCompany": "Firma",
    "detail.specValue": "Bedel",
    "detail.specScope": "İşin Adı",
    "detail.specDate": "Tarih",
    "detail.specLocation": "Konum",
    "detail.specCategory": "Kategori",
    "detail.inquire": "Bu Proje Hakkında Bilgi Al",
    "detail.prev": "Önceki",
    "detail.next": "Sonraki",
    "detail.related": "Benzer Projeler",
    "detail.allInCategory": "Kategorideki tümü",
    "detail.mailSubject": "Teklif / Bilgi: {name}",
    "detail.mailBody": 'Merhaba, "{name}" projeniz hakkında bilgi almak istiyorum.',

    "contact.headerTitle": "İletişim",
    "contact.headerSubtitle":
      "Projeleriniz için bizimle iletişime geçin. Uzman ekibimiz en kısa sürede size dönüş yapsın.",
    "contact.cardAddress": "Adres",
    "contact.cardPhone": "Telefon",
    "contact.cardEmail": "E-posta",
    "contact.writeEyebrow": "Bize Yazın",
    "contact.formTitle": "Bize mesaj gönderin",
    "contact.formDesc":
      "Formu doldurun; mesajınız e-posta uygulamanızda hazır şekilde açılsın, gönderin.",
    "contact.phName": "Ad Soyad",
    "contact.phPhone": "Telefon",
    "contact.phSubject": "Konu",
    "contact.phMessage": "Mesajınız",
    "contact.formSubmit": "E-posta ile Gönder",
    "contact.hours": "PAZARTESİ – CUMARTESİ · 08:30 – 18:00",
    "contact.formDefaultSubject": "İletişim Formu — {name}",
    "contact.bodyName": "Ad Soyad",
    "contact.bodyPhone": "Telefon",
    "contact.bodySubject": "Konu",
    "contact.mapTitle": "KYT Yapı Teknolojileri Konum",
    "contact.directions": "Yol Tarifi Al",

    "notfound.msg": "Aradığınız sayfa bulunamadı.",
    "notfound.home": "Anasayfa",
    "notfound.projects": "Projeler",

    "pageheader.home": "Anasayfa",
  },

  en: {
    "nav.home": "Home",
    "nav.about": "About",
    "nav.services": "Services",
    "nav.projects": "Projects",
    "nav.contact": "Contact",

    "common.catalogOnline": "Online Catalog",
    "common.catalogDownload": "Download Catalog",
    "common.contactCta": "Get in Touch",
    "common.emailSend": "Send Email",
    "common.exploreProjects": "Explore Our Projects",
    "common.allProjects": "All Projects",
    "common.allServices": "All services",
    "common.viewProject": "View Project",
    "common.getQuote": "Get a Free Quote",

    "footer.desc":
      "Since 1993, we have powered hospital, stadium, shopping center, industrial facility and residential projects in electrical contracting and engineering.",
    "footer.menu": "Menu",
    "footer.projectCategories": "Project Categories",
    "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",
    "footer.quickQuote": "Get a quick quote",
    "footer.kvkk": "Privacy Notice (KVKK)",
    "footer.cookies": "Cookie Policy",
    "footer.legalCol": "Legal",

    "cookie.text": "Our website only uses strictly necessary local storage required to function; it does not use any analytics or advertising cookies.",
    "cookie.accept": "Got it",
    "cookie.policy": "Cookie Policy",

    "home.heroEyebrow": "Electrical & Engineering",
    "home.heroLines": ["We power", "the buildings of", "the future."],
    "home.heroHighlight": "power",
    "home.heroPara":
      "Your trusted solution partner, delivering electrical contracting and engineering solutions for hospitals, stadiums, shopping centers and industrial facilities since {since}.",
    "home.scroll": "Scroll",
    "home.trustedBy": "The solution partner of trusted brands",
    "home.sec01Eyebrow": "Corporate",
    "home.sec01Title": "Not money — earning customers and friends is our most important philosophy.",
    "home.sec01Bullets": [
      "An expert technical team that never compromises on standards",
      "Delivery on time — even ahead of schedule",
      "Energy distribution systems that last for years",
    ],
    "home.aboutMore": "More about us",
    "home.sec02Eyebrow": "Our Services",
    "home.sec03Eyebrow": "Recently Completed",
    "home.sec03Title": "Featured Projects",
    "home.sec03Desc": "Large-scale electrical and engineering projects we have recently completed.",
    "home.sec04Eyebrow": "Our References",
    "home.sec04Title": "A Selection of Our Projects",
    "home.sec04Desc":
      "More than 42 completed projects across healthcare, sports, industrial, shopping center and public buildings.",
    "home.certEyebrow": "Our Certifications",
    "home.certTitle": "Service at International Standards",
    "home.certDesc":
      "We manage our business processes with quality, environmental and occupational safety standards.",
    "home.ctaEyebrow": "Contact",
    "home.ctaTitle": "Looking for an electrical and engineering solution for your project?",
    "home.serviceHighlights": [
      { title: "Electrical Contracting", desc: "LV-MV power transmission lines, transformer substations and distribution panels." },
      { title: "Automation Systems", desc: "Building, CCTV and perimeter security automation solutions." },
      { title: "Lighting & Compensation", desc: "Efficient lighting and reactive power compensation systems." },
      { title: "Security & Fire", desc: "Access control, fire alarm and security systems." },
    ],

    "about.headerTitle": "About",
    "about.headerSubtitle":
      "{legal} — your trusted partner in electrical and engineering works since {since}.",
    "about.introEyebrow": "About Us",
    "about.introTitle": "Engineering that makes electrical energy efficient and safe.",
    "about.introDesc":
      "Operating in engineering, consultancy, contracting and sales within the electrical sector in Turkey and around the world, our company serves with its expert technical staff and a conscientious sense of responsibility.",
    "about.actEyebrow": "Our Activity Areas",
    "about.certEyebrow": "Our Certifications",
    "about.certTitle": "Our Certificates & Standards",
    "about.reachUs": "Reach Us",

    "services.headerTitle": "Our Services",
    "services.headerSubtitleSuffix":
      " — end-to-end electrical and engineering solutions, from consultancy to commissioning.",
    "services.eyebrow": "Electrical & Engineering",
    "services.whyEyebrow": "Why KYT?",
    "services.whyTitle": "A single-source solution from design to commissioning.",
    "services.ctaTitle": "Let us build a solution tailored to your needs.",
    "services.steps": [
      { t: "Design & Engineering", d: "Project design, calculations and implementation drawings." },
      { t: "Supply & Installation", d: "Panel manufacturing, cabling, termination and on-site installation." },
      { t: "Testing & Commissioning", d: "Tests, automation and seamless commissioning." },
    ],

    "projects.headerTitle": "Our Projects",
    "projects.headerSubtitle":
      "Healthcare, sports, industrial, shopping center, education, social facility and residential projects we have completed since 1993.",
    "projects.countSuffix": "projects",
    "projects.refEyebrow": "Other References",
    "projects.refTitle": "Organizations We Worked With",
    "projects.refDesc":
      "In addition to our project galleries, a selection of references we have provided electrical and engineering services to over the years.",

    "detail.crumb": "Project Detail",
    "detail.notFound": "Project not found",
    "detail.backAll": "Back to all projects",
    "detail.specsTitle": "Project Details",
    "detail.specCompany": "Company",
    "detail.specValue": "Value",
    "detail.specScope": "Scope of Work",
    "detail.specDate": "Date",
    "detail.specLocation": "Location",
    "detail.specCategory": "Category",
    "detail.inquire": "Inquire About This Project",
    "detail.prev": "Previous",
    "detail.next": "Next",
    "detail.related": "Related Projects",
    "detail.allInCategory": "All in category",
    "detail.mailSubject": "Quote / Info: {name}",
    "detail.mailBody": 'Hello, I would like to get information about your "{name}" project.',

    "contact.headerTitle": "Contact",
    "contact.headerSubtitle":
      "Get in touch with us for your projects. Our expert team will get back to you as soon as possible.",
    "contact.cardAddress": "Address",
    "contact.cardPhone": "Phone",
    "contact.cardEmail": "Email",
    "contact.writeEyebrow": "Write to Us",
    "contact.formTitle": "Send us a message",
    "contact.formDesc":
      "Fill in the form; your message will open ready in your email app — just send it.",
    "contact.phName": "Full Name",
    "contact.phPhone": "Phone",
    "contact.phSubject": "Subject",
    "contact.phMessage": "Your Message",
    "contact.formSubmit": "Send via Email",
    "contact.hours": "MONDAY – SATURDAY · 08:30 – 18:00",
    "contact.formDefaultSubject": "Contact Form — {name}",
    "contact.bodyName": "Full Name",
    "contact.bodyPhone": "Phone",
    "contact.bodySubject": "Subject",
    "contact.mapTitle": "KYT Yapı Teknolojileri Location",
    "contact.directions": "Get Directions",

    "notfound.msg": "The page you are looking for was not found.",
    "notfound.home": "Home",
    "notfound.projects": "Projects",

    "pageheader.home": "Home",
  },
};
